import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';
import { DRNTouchableWrapper } from '@traveloka/district-ui';

import R from 'common/res/R';

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: R.spacing.xs,
    paddingVertical: R.spacing.s,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: R.color.uiLightSecondary,
  },
  label: R.typography.weightBold,
});

function BusAutoCompleteStationItem({ item, onPress }) {
  const { label, subLabel } = item;

  return (
    <DRNTouchableWrapper onPress={() => onPress(item)}>
      <View style={styles.container}>
        <Text style={styles.label}>{label}</Text>
        {Boolean(subLabel) && <Text>{subLabel}</Text>}
      </View>
    </DRNTouchableWrapper>
  );
}

BusAutoCompleteStationItem.propTypes = {
  item: PropTypes.shape({
    label: PropTypes.string.isRequired,
    subLabel: PropTypes.string,
  }).isRequired,
  onPress: PropTypes.func.isRequired,
};

export default BusAutoCompleteStationItem;
